import { hex as s } from "./atoms-v2954.js";
import { hsla as t } from "./atoms-v2955.js";
import { rgba as e } from "./atoms-v2956.js";
const p = {
  test: (r) => e.test(r) || s.test(r) || t.test(r),
  parse: (r) => e.test(r) ? e.parse(r) : t.test(r) ? t.parse(r) : s.parse(r),
  transform: (r) => typeof r == "string" ? r : r.hasOwnProperty("red") ? e.transform(r) : t.transform(r)
};
export {
  p as color
};
